import type { AppProps } from 'next/app';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';

import VersionBadge from '@/components/molecules/version-badge/VersionBadge.component';
import { AppProviders } from '@/Providers/AppProviders';

import AppLayout from '../Providers/appLayout';

import './global.css';
import '../utils/polyfills';

// ThemeProvider (and all MUI) loads asynchronously — never blocks first paint.
// Children render immediately without the theme; MUI applies once the chunk arrives.
const ThemedWrapper = dynamic(() => import('@/Providers/ThemedWrapper'), {
  ssr: false,
  loading: () => <></>,
});

const host = typeof window !== 'undefined' ? window.location.host : '';
const userAgent = typeof window !== 'undefined' ? navigator.userAgent : '';

export default function App({ Component, pageProps }: AppProps) {
  const router = useRouter();
  const locale = router.asPath?.split('/')[1] === 'en' ? 'en' : 'th';
  return (
    <ThemedWrapper>
      <Head>
        <title>Lotuss MY</title>
      </Head>
      <AppProviders locale={locale} userAgent={userAgent} host={host}>
        <AppLayout>
          <Component {...pageProps} />
          <VersionBadge />
        </AppLayout>
      </AppProviders>
    </ThemedWrapper>
  );
}
